import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP } from "@/constants/testIds";

const PHONE = "7975259104";
const WA_MESSAGE = "Hello HR ENTERPRISES,\n\nI visited your website and would like to discuss my project. Please let me know a convenient time to connect.";
const WA_LINK = `https://wa.me/91${PHONE}?text=${encodeURIComponent(WA_MESSAGE)}`;

const WhatsAppFloat = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          href={WA_LINK}
          target="_blank"
          rel="noreferrer"
          data-testid={WHATSAPP.float}
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 20 }}
          transition={{ duration: 0.35, ease: [0.2, 0.8, 0.2, 1] }}
          aria-label="Chat with HR Enterprises on WhatsApp"
          className="group fixed bottom-24 right-5 z-40 grid h-14 w-14 place-items-center rounded-full border border-[var(--gold)]/40 bg-gradient-to-br from-[#f6d872] via-[#d4af37] to-[#a8871f] text-[#0a0a0a] shadow-[0_18px_45px_-12px_rgba(212,175,55,0.6)] transition-transform duration-300 hover:scale-105 sm:right-8"
        >
          <MessageCircle className="h-6 w-6" strokeWidth={2} />
          <span className="pointer-events-none absolute inset-0 -z-10 animate-ping rounded-full bg-[var(--gold)]/40 opacity-40" />
        </motion.a>
      )}
    </AnimatePresence>
  );
};

export default WhatsAppFloat;
